export default __webpack_public_path__ + "static/media/PageLoader.bf5f9ebf.gif";